import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SignInPage from '../../pages/signin';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <span className="material-icons text-6xl text-producthub-primary animate-spin">
            hourglass_empty
          </span>
          <div className="text-gray-600 text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <SignInPage />;
};

export default ProtectedRoute; 